import { render } from "./All.vue?vue&type=template&id=5c4fef6b&scoped=true"
import script from "./All.vue?vue&type=script&lang=js"
export * from "./All.vue?vue&type=script&lang=js"

import "./All.vue?vue&type=style&index=0&id=5c4fef6b&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4fef6b"]])

export default __exports__